import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ReactToPrint from 'react-to-print';
import * as styles from './print-report-detail-btn.module.scss';
import { Spin } from 'antd';
import { BasicButton } from '../../../../../assets/common';
import { useParams } from 'react-router-dom';

const PrintReportDetailBtn = (props) => {
  const { componentRef, style, isDisabled, selectedItem, handleBeforePrint, handleAfterPrint } = props;
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const fileName = `${id}_BePCB Report _FY${selectedItem?.year}`;

  const reactToPrintTrigger = () => {
    return (
      <div className={styles.control}>
        <div className="mt-2">
          <div className="d-flex align-items-center justify-content-end">
            <Spin spinning={loading} size="small">
              <BasicButton disabled={loading || isDisabled} data-testid="printBtn" style={style}>
                Print
              </BasicButton>
            </Spin>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div>
      <ReactToPrint
        content={() => {
          const cloneDom = componentRef.current.cloneNode(true);
          return cloneDom;
        }}
        removeAfterPrint
        documentTitle={fileName}
        onBeforeGetContent={() => {
          setLoading(true);
          handleBeforePrint();
        }}
        onBeforePrint={() => {
          setLoading(false);
        }}
        trigger={reactToPrintTrigger}
        onAfterPrint={() => handleAfterPrint()}
      />
    </div>
  );
};
PrintReportDetailBtn.propTypes = {
  componentRef: PropTypes.object,
  positionName: PropTypes.string,
  dateApproved: PropTypes.string,
  customFileName: PropTypes.string,
  style: PropTypes.object,
  isDisabled: PropTypes.bool,
  setIsPrinting: PropTypes.func,
};

export default PrintReportDetailBtn;
